import { api } from '../client/client.js';
import { formatDateTime } from '../format/format.js';

export function getCurrencyRate() {
  return api.get('/dashboard/currency').then((data) => Number(data.rate) || null);
}

export function getDashboard() {
  return api.get('/dashboard').then((data) => ({
    ...data,
    recent_transactions: (data.recent_transactions || []).map((tx) => ({
      id: tx.id,
      userId: tx.user_label || '—',
      type: tx.type,
      amount: Number(tx.amount),
      date: formatDateTime(tx.created_at),
      status: tx.status,
    })),
    recent_users: (data.recent_users || []).map((u) => ({
      id: u.id,
      username: u.username ? `@${u.username}` : '—',
      nickname: u.nickname || '—',
      status: u.status,
    })),
    server_statuses: (data.server_statuses || []).map((s) => ({
      status: s.state,
      count: Number(s.count),
    })),
    low_balance: (data.low_balance || []).map((u) => ({
      id: u.id,
      username: u.username ? `@${u.username}` : '—',
      nickname: u.nickname || null,
      balance: Number(u.balance),
      renew_price: u.renew_price != null ? Number(u.renew_price) : null,
    })),
    recent_plans: (data.recent_plans || []).map((p) => ({
      id: p.id,
      name: p.name,
      price: Number(p.price),
      status: p.status,
    })),
  }));
}
